// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 12H13.5V16H10.5V12Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1L21 6.58579V23H3V1H15.4142ZM14.5 7.5H19L14.5 3V7.5ZM10.5 10C9.39543 10 8.5 10.8954 8.5 12V16C8.5 17.1046 9.39543 18 10.5 18H13.5C14.6046 18 15.5 17.1046 15.5 16V12C15.5 10.8954 14.6046 10 13.5 10H10.5Z"}}]};

const FileOutlookFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-outlook-filled',
    ref,
    icon: element,
  },
));

FileOutlookFilledIcon.displayName = 'FileOutlookFilledIcon';

export default FileOutlookFilledIcon;
